import { Pipe, PipeTransform } from '@angular/core';

import { Account } from '@accounts/models/account';
import { AccountType } from '@accounts/models/account-type';
import { Module } from '@modules/models/module';

@Pipe({
  name: 'moduleHasClientAccess',
  standalone: true
})
export class ModuleHasClientAccessPipe implements PipeTransform {
  transform(module: Module, selectedAccount: Account): boolean {
    if (selectedAccount?.accountType === AccountType.SystemAdmin) {
      return true;
    }

    return selectedAccount?.client?.modules?.includes(module.id) ?? false;
  }
}
